// Copyright (c) 2015, Neo Pacific Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
nxf._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = nxf._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = nxf._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = nxf._;

nxf.get_languages = function () {
	if (!nxf.languages) {
		nxf.languages = [];
		$.each(nxf.boot.lang_dict, function (lang, value) {
			nxf.languages.push({ label: lang, value: value });
		});
		nxf.languages = nxf.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return nxf.languages;
};
